import { CONFIGURATION_TABS as ANALYTICS_TABS } from "../../../constants/configurationNavigation";

import React from "react";
import { Tabs, Box, Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { hasAnyPermission } from "../../../utils/permissions";
import { PERMISSION_MODULES } from "../../../constants/permissions";

export default function TabsBar() {
    const navigate = useNavigate();
    const location = useLocation();

    const visibleTabs = ANALYTICS_TABS.filter((tab) =>
        hasAnyPermission(PERMISSION_MODULES.CONFIGURATION, tab.permissions)
    );

    // route is like: /analytics/product
    const currentTab = location.pathname;
    return (
        <Box sx={{ px: 2 }}>
            <Tabs
                value={currentTab}
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
                sx={{
                    minHeight: "40px",
                    py: 1,
                    "& .MuiTabs-indicator": {
                        display: "none",
                    },
                }}
            >
                {visibleTabs.map((tab) => (
                    <Button
                        key={tab.value}
                        value={tab.value}
                        label={tab.label}
                        onClick={() => navigate(`/${tab.value}`)}
                        sx={{
                            textTransform: "none",
                            minHeight: "32px",
                            borderRadius: "3px",
                            mx: 0.5,
                            px: 2,
                            fontSize: "14px",
                            fontWeight: 500,
                            backgroundColor:
                                currentTab === `/${tab.value}` ? "#154D8F" : "transparent",
                            color: currentTab === `/${tab.value}` ? "#fff" : "#000",
                            "&.Mui-selected": {
                                color: "#fff",
                                backgroundColor: "#154D8F",
                            },
                            "&:hover": {
                                backgroundColor:
                                    currentTab === `/${tab.value}` ? "#154D8F" : "#f5f5f5",
                            },
                            "&.Mui-disabled": {
                                color: "#9e9e9e",
                                backgroundColor: "#f0f0f0",
                                opacity: 1, // prevent faded look
                            },
                        }}
                    >
                        {tab.label}
                    </Button>
                ))}
            </Tabs>
        </Box>
    );
}
